function transformUserComplianceToLowercase(source) {
    return {
        emailVerificationStatus: {
            status: source.EmailVerificationStatus.Status,
            code: source.EmailVerificationStatus.Code,
        },
        phoneVerificationStatus: {
            status: source.PhoneVerificationStatus.Status,
            code: source.PhoneVerificationStatus.Code,
        },
        idVerificationStatus: source.IdVerificationStatus,
        ageVerificationStatus: source.AgeVerificationStatus,
        adverseMediaVerificationStatus: source.AdverseMediaVerificationStatus,
        addressVerificationStatus: source.AddressVerificationStatus,
        sourceOfWealthVerificationStatus: source.SourceOfWealthVerificationStatus,
        sourceOfFundsVerificationStatus: source.SourceOfFundsVerificationStatus,
        kycVerificationStatus: source.KycVerificationStatus,
        multipleAccountCheckStatus: source.MultipleAccountCheckStatus,
        selfExclusionCheckStatus: source.SelfExclusionCheckStatus,
        pepVerificationStatus: source.PepVerificationStatus,
        sanctionVerificationStatus: source.SanctionVerificationStatus,
        kycLevel: source.KycLevel,
        isLoginAllowed: source.IsLoginAllowed,
        isWageringAllowed: source.IsWageringAllowed,
        isDepositAllowed: source.IsDepositAllowed,
        isWithdrawAllowed: source.IsWithdrawAllowed,
        isPromotionsAllowed: source.IsPromotionsAllowed,
        vatCountryAlpha2Code: source.VatCountryAlpha2Code,
    };
}

export { transformUserComplianceToLowercase };
